/* QST — SPD Split Payment front-end adjustments.
 *
 * Loaded from snippets/buy-buttons.liquid, so it runs on every product page.
 * Two jobs:
 *   1. Rewrite SPD's deposit note (their admin exposes no field for that text).
 *   2. Pre-select "Full payment" instead of the deposit.
 *
 * To change the wording, edit LINE_BALANCE / LINE_SHOPPAY.
 * To stop forcing the Full payment default, delete the applyDefault function and the
 * two calls to it in tick(). Everything else keeps working.
 */
(function () {
  /* buy-buttons.liquid and the shop_pay_terms block can both pull this file in.
     Run once per page either way. */
  if (window.__qstSpdNoteInit) return;
  window.__qstSpdNoteInit = true;

  var LINE_BALANCE =
    'The remaining balance, including shipping and tax, is charged automatically to the same card in 30 days.';
  var LINE_SHOPPAY =
    "This option can't be combined with Shop Pay Installments — choose one or the other.";

  /* ---- 1. Deposit note ------------------------------------------------ */

  function depositPercent(note) {
    var option = note.closest ? note.closest('.spp2__widget-option') : null;
    var label = option && option.querySelector('.spp2__payment-option-label');
    var match = label && label.textContent.match(/(\d+)\s*%/);
    return match ? match[1] : null;
  }

  function rewriteNotes() {
    var notes = document.querySelectorAll('.spp2__widget-note');
    for (var i = 0; i < notes.length; i++) {
      var note = notes[i];
      if (note.getAttribute('data-qst-note') === '1') continue;
      var pct = depositPercent(note);
      note.textContent =
        (pct ? 'Initial payment: ' + pct + '% today.\n' : '') +
        LINE_BALANCE + '\n' + LINE_SHOPPAY;
      note.style.whiteSpace = 'pre-line';
      note.setAttribute('data-qst-note', '1');
    }
  }

  /* ---- 2. Default to Full payment ------------------------------------- */

  /* SPD ships with the deposit pre-selected, so a customer who never touches the
     widget checks out paying half. There is no setting for this in the app, so we
     flip it here. Once the customer picks an option themselves we never touch it
     again — userChose latches on the first real interaction. */

  var userChose = false;
  var programmatic = false;

  function noteInteraction(event) {
    if (programmatic) return;
    var target = event.target;
    if (target && target.closest && target.closest('.spp2__widget')) userChose = true;
  }
  document.addEventListener('click', noteInteraction, true);
  document.addEventListener('change', noteInteraction, true);

  function applyDefault() {
    if (userChose) return;
    var full = document.getElementById('payment-option-full');
    /* Already correct, or the widget has not rendered yet — nothing to do.
       This check is also what stops the MutationObserver looping. */
    if (!full || full.checked) return;
    var label = document.querySelector('label[for="payment-option-full"]');
    programmatic = true;
    (label || full).click();
    setTimeout(function () { programmatic = false; }, 0);
  }

  /* ---- wiring --------------------------------------------------------- */

  function tick() {
    rewriteNotes();
    applyDefault();
  }

  /* SPD injects its widget asynchronously and re-renders on variant change, so watch
     for it rather than running once. */
  if (window.MutationObserver) {
    new MutationObserver(tick).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', tick);
  }
  tick();
})();
